export function correctionRequired(row, corrections = new Set()) {
  return corrections.has(Number(row.id)) || row.review_change_required === true ||
    row.review_change_required === 1 || row.review_change_required === 'true' ||
    (row.eligibility?.reasons || []).includes('REVIEW_CORRECTION_OPEN');
}
export function canBulkDispatch(row, corrections = new Set()) {
  return row.eligibility?.ready === true && !correctionRequired(row, corrections);
}
export function recipientKey(row) {
  const s = row.eligibility?.snapshot;
  return s?.agent_pk && s?.target_id ? JSON.stringify([s.agent_pk, s.target_id, s.target_type]) : '';
}
export function recipients(rows) {
  const found = new Map();
  for (const row of rows) {
    const key = recipientKey(row), s = row.eligibility?.snapshot;
    if (key && !found.has(key)) found.set(key, {key, agent: s.agent_name, agentPk: s.agent_pk,
      name: s.target_name, id: s.target_id, type: s.target_type});
  }
  return [...found.values()].sort((a,b) => String(a.agent).localeCompare(String(b.agent), 'de'));
}
export function eligibleSelection(rows, selected, key, corrections = new Set()) {
  return rows.filter(row => selected.has(Number(row.id)) && canBulkDispatch(row, corrections) && recipientKey(row) === key);
}
export function mergeRows(previous, next) {
  return [...new Map([...previous, ...next].map(row => [Number(row.id), row])).values()];
}
export function validDispatchPage(data) {
  return Array.isArray(data?.orders) && data.orders.every(row => Number.isSafeInteger(Number(row.id)) &&
    row.eligibility && typeof row.eligibility.ready === 'boolean' && Array.isArray(row.eligibility.reasons));
}
export const dispatchReasons = {
  PUBLISHED_VERSION_OBSERVATION_REQUIRED:'Aktuelle veröffentlichte Textversion mit der Extension erfassen und neu laden',
  PUBLISHED_VERSION_NOT_RELEASED:'Diese Textversion noch einmal ausdrücklich freigeben',
  TEXT_VERSION_ALREADY_RESERVED:'Diese Textversion besitzt bereits einen Versandauftrag; keine Wiederholung',
  LEGACY_TEXT_BASELINE_REQUIRED:'Altversand ohne Textreferenz: erst eine sichere Referenz für spätere Änderungen erfassen',
  TEXT_VERSION_CHANGED:'Veröffentlichter Text wurde nach der Freigabe geändert; Versand gestoppt',
  TEXT_VERSION_STALE:'Textversion geändert: neu laden und erneut prüfen',
  HISTORICAL_STATUS_UNKNOWN:'Bisherigen Versand prüfen', REVIEW_REVISION_NOT_APPROVED:'Review-Version noch nicht freigegeben',
  REVIEW_CORRECTION_OPEN:'Änderung offen · ausschließlich einzeln prüfen', STATUS_NOT_REVIEWED:'Bestellstatus ist nicht Reviewed',
  TARGET_UNCONFIRMED:'WeChat-Ziel nicht bestätigt', COLLECTOR_OFFLINE:'Collector offline', ALREADY_SENT:'Bereits gesendet',
  INACTIVE_AGENT_POLICY_NOT_RELEASED:'Inaktiver Agent · manuell prüfen', FINANCIAL_HISTORY_PROTECTED:'Geschäftshistorie geschützt',
  MANUAL_CORRECTION_NO_LONGER_OPEN:'Die Änderungsmarkierung ist nicht mehr offen',
  DISPATCH_HISTORY_REQUIRES_MANUAL_REVIEW:'Vorhandene Versandhistorie zuerst prüfen; keine automatische Wiederholung',
  PREVIOUS_ATTEMPT_REQUIRES_MANUAL_REVIEW:'Vorherigen Versandversuch zuerst prüfen',
};
